import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { action, computed, observable } from 'mobx';
// import moment from 'moment';
import { EnumAPI } from '../../../apis';
import { BaseModel, BasesController } from '../../../controller/bases';
import { AjaxBasics } from '../../../helpers';

@BindAll()
export class PersonalCenterController extends BasesController {
  Model = new BaseModel({ type: 'object' });

  constructor() {
    super();
    this.reset({
      details: EnumAPI.sitResource_get_layout_findByToken,
      detailsParams: {
        valueGetter(res) {
          console.log('～～～布局～～～', res);
          const content = lodash.find(lodash.get(res, 'layoutConfigList'), [
            'platform',
            'mobile',
          ]);
          try {
            if (content) {
              // res.content = []
              res.content = JSON.parse(lodash.get(content, 'contentJson'));
            }
          } catch (error) {
            console.log('error:', error);
            res.content = [];
          }
          return res;
        },
      },
    });
  }

  // 个人中心页面存放所有菜单的badge数据
  @observable
  badgeValue = {};

  @computed
  get content() {
    return this.Details.Model.get('content');
  }

  /**
   *  商机看板数据
   */
  @computed
  get businessInfo() {
    return lodash.get(this.Model.value, 'businessInfo', {});
  }

  /**
   *  签约商-经销商看板数据
   */
  @computed
  get dealerInfo() {
    return lodash.get(this.Model.value, 'dealerInfo', {});
  }

  /**
   *  签约商-销售看板数据
   */
  @computed
  get salesInfoContractors() {
    return lodash.get(this.Model.value, 'salesInfoContractors', {});
  }

  /**
   *  注册商-销售看板数据
   */
  @computed
  get salesInfoRegistrar() {
    return lodash.get(this.Model.value, 'salesInfoRegistrar', {});
  }

  /**
   *  当前财年
   */
  fiscalYear(prefix = true, initTime: Date | null = null) {
    const date = initTime || new Date();
    const fiscalQuarter = this.fiscalQuarter(false, new Date(date.getTime())); // 克隆日期对象

    if (Number(fiscalQuarter) === 4) {
      date.setFullYear(date.getFullYear() - 1); // 减去 1 年
      return `${prefix ? 'FY' : ''}${date.getFullYear()}`;
    }
    return `${prefix ? 'FY' : ''}${date.getFullYear()}`;
  }
  // fiscalYear(prefix = true, initTime = null) {
  //   const date = initTime || moment();
  //   if (
  //     lodash.toNumber(this.fiscalQuarter(false, lodash.cloneDeep(date))) === 4
  //   ) {
  //     return `${prefix ? 'FY' : ''}${date.subtract(1, 'year').format('YYYY')}`;
  //   }
  //   return `${prefix ? 'FY' : ''}${date.format('YYYY')}`;
  // }

  /**
   *  当前财季
   */
  fiscalQuarter(prefix = true, initTime: Date | null = null) {
    const date = initTime || new Date();
    const currentMonth = date.getMonth(); // 获取当前月份（0-11）

    // 减去一个季度（3 个月）
    date.setMonth(currentMonth - 3);

    // 计算季度（1-4）
    const quarter = Math.floor(date.getMonth() / 3) + 1;

    return `${prefix ? 'Q' : ''}${quarter}`;
  }
  // fiscalQuarter(prefix = true, initTime = null) {
  //   const date = initTime || moment();
  //   return `${prefix ? 'Q' : ''}${date.subtract(1, 'quarter').quarter()}`;
  // }

  /**
   * @des 存储用户常用菜单
   */
  async onSaveFavoriteMenu(body) {
    return await AjaxBasics.request({
      ...EnumAPI.mobile_save_menu_sort,
      body,
    });
  }

  /**
   * @des 获取用户常用菜单
   */
  async onGetFavoriteMenu() {
    return await AjaxBasics.request({
      ...EnumAPI.mobile_get_menu_sort,
    });
  }

  /**
   * @des 获取待办事项
   */
  async onToDoList() {
    return await AjaxBasics.request({
      ...EnumAPI.syncTask_component_schedule_findByToken,
    });
  }

  /**
   * @des 获取待办详情
   */
  async onToDoDetail(body) {
    return await AjaxBasics.request({
      ...EnumAPI.syncTask_component_schedule_get_by_id,
      body,
    });
  }

  // 获取经销商看板信息
  async getDealerData(body) {
    try {
      const api = EnumAPI.workbench_banner_dealer_component;
      const res: any = await AjaxBasics.request<any>({
        ...api,
        body,
      });

      this.Model.merge({ dealerInfo: res });
    } catch {}
  }

  // 获取签约商销售看板信息
  async getContractorsSalesData(body) {
    try {
      const api = EnumAPI.workbench_banner_sales_component;

      const res: any = await AjaxBasics.request<any>({
        ...api,
        body,
      });

      this.Model.merge({ salesInfoContractors: res });
    } catch {}
  }

  // banner获取smb奖励看板信息（新版）
  async getRewardQuarterInfo(isCts = false) {
    try {
      const date = new Date();
      date.setDate(date.getDate() - 3); // 减去 3 天
      const formattedDate = date.toISOString().split('T')[0]; // 格式化为 'YYYY-MM-DD'

      const api = EnumAPI.workbench_reward_quarter_banner_component;
      const res: any = await AjaxBasics.request<any>({
        ...api,
        body: {
          fq: this.fiscalQuarter(true, new Date(formattedDate)),
          fy: this.fiscalYear(true, new Date(formattedDate)),
        },
      });
      // this.Model.merge({ bannerRewardInfo: res });
      return res;
    } catch {}
  }

  // 获取商机看板信息
  @action
  async getBusinessData(body) {
    try {
      const api = EnumAPI.workbench_banner_bus_component;

      const res: any = await AjaxBasics.request<any>({
        ...api,
        body,
      });

      // 商机看板漏斗图
      const optionFunnel = {
        series: [
          {
            type: 'funnel',
            left: 0,
            top: 4,
            bottom: 4,
            width: '55%',
            min: 0,
            max: 100,
            minSize: 0,
            maxSize: 0,
            gap: 2,
            color: ['#0050B3', '#1890FF', '#40A9FF', '#69C0FF'],
            itemStyle: { borderWidth: 0 },
            label: {
              color: '#333',
              fontSize: 12,
              formatter: function (params) {
                return (
                  params.data.showTitleOne +
                  params.data.showValueOne +
                  '条\n' +
                  params.data.showTitleTwo +
                  params.data.showValueTwo +
                  '台'
                );
              },
            },
            labelLine: {
              length: 100,
              lineStyle: {
                width: 1,
                type: 'solid',
              },
            },
            data: [
              {
                value: 80,
                name: '提报线索',
                unit: '',
                showTitleOne: '提报线索：',
                showValueOne: lodash.get(res, 'reportBusNum'),
                showTitleTwo: '产品需求：',
                showValueTwo: lodash.get(res, 'reportBusProductNum'),
              },
              {
                value: 60,
                rate: lodash.get(res, 'checkBusApprovalPassRate'),
                name: '有效线索',
                unit: '通过率',
                showTitleOne: '有效线索：',
                showValueOne: lodash.get(res, 'checkBusNum'),
                showTitleTwo: '产品需求：',
                showValueTwo: lodash.get(res, 'checkProductNum'),
              },
              {
                value: 40,
                rate: lodash.get(res, 'transferOrderApprovalPassRate'),
                name: '转单商机',
                unit: '转单率',
                showTitleOne: '转订单商机：',
                showValueOne: lodash.get(res, 'transferOrderNum'),
                showTitleTwo: '转订单产品：',
                showValueTwo: lodash.get(res, 'transferOrderProductNum'),
              },
              {
                value: 20,
                rate: lodash.get(res, 'deliveryApprovalPassRate'),
                name: '交付商机',
                unit: '交付率',
                showTitleOne: '交付商机：',
                showValueOne: lodash.get(res, 'deliveryBusNum'),
                showTitleTwo: '交付产品：',
                showValueTwo: lodash.get(res, 'deliveryProductNum'),
              },
            ],
          },
        ],
      };

      // 商机看板漏斗图
      const optionFunnel2 = {
        tooltip: {
          trigger: 'item',
          formatter: function (params) {
            if (params.data.unit) {
              return (
                params.data.name +
                '<br />' +
                '<span style="font-weight:600;">' +
                params.data.rate +
                '%</span>' +
                '&nbsp' +
                params.data.unit
              );
            }
          },
        },
        series: [
          {
            type: 'funnel',
            left: 0,
            top: 4,
            bottom: 4,
            width: '60%',
            min: 0,
            max: 100,
            minSize: '30%',
            maxSize: '100%',
            gap: 2,
            color: ['#0050B3', '#1890FF', '#40A9FF', '#69C0FF'],
            itemStyle: { borderWidth: 0 },
            label: {
              color: '#e8e8e8',
              fontSize: 12,
              position: 'inside',
              formatter: '{b}',
            },
            labelLine: {
              length: 10,
              lineStyle: {
                width: 1,
                type: 'solid',
              },
            },
            data: [
              {
                value: 80,
                name: '提报线索',
                unit: '',
                showTitleOne: '提报线索：',
                showValueOne: lodash.get(res, 'reportBusNum'),
                showTitleTwo: '产品需求：',
                showValueTwo: lodash.get(res, 'reportBusProductNum'),
              },
              {
                value: 60,
                rate: lodash.get(res, 'checkBusApprovalPassRate'),
                name: '有效线索',
                unit: '通过率',
                showTitleOne: '有效线索：',
                showValueOne: lodash.get(res, 'checkBusNum'),
                showTitleTwo: '产品需求：',
                showValueTwo: lodash.get(res, 'checkProductNum'),
              },
              {
                value: 40,
                rate: lodash.get(res, 'transferOrderApprovalPassRate'),
                name: '转单商机',
                unit: '转单率',
                showTitleOne: '转订单商机：',
                showValueOne: lodash.get(res, 'transferOrderNum'),
                showTitleTwo: '转订单产品：',
                showValueTwo: lodash.get(res, 'transferOrderProductNum'),
              },
              {
                value: 20,
                rate: lodash.get(res, 'deliveryApprovalPassRate'),
                name: '交付商机',
                unit: '交付率',
                showTitleOne: '交付商机：',
                showValueOne: lodash.get(res, 'deliveryBusNum'),
                showTitleTwo: '交付产品：',
                showValueTwo: lodash.get(res, 'deliveryProductNum'),
              },
            ],
          },
        ],
      };

      res.optionFunnel = optionFunnel;
      res.optionFunnel2 = optionFunnel2;
      this.Model.merge({ businessInfo: res });
    } catch {}
  }

  // 获取注册商销售看板信息
  @action
  async getRegistrarSalesData(body) {
    try {
      const api = EnumAPI.workbench_banner_sales_component;

      const res: any = await AjaxBasics.request<any>({
        ...api,
        body,
      });

      const option: Object = lodash.get(res, 'productLineOption');

      // 存一下数据为0的
      const grayArray = lodash.filter(
        lodash.get(option, 'series[0].data', []),
        (item) => item.situation === 0,
      );
      const graylist = lodash.map(grayArray, (item) => item.lineOrGroup);
      let selected = {};
      lodash.forEach(graylist, (item) => {
        selected[item] = false;
      });
      // 销售看板饼图
      const optionPie = {
        tooltip: {
          confine: true,
          trigger: 'item',
          formatter: function (params) {
            return (
              params.name +
              '：' +
              '<span style="font-weight:600;">' +
              params.value +
              '</span>' +
              '<br />' +
              '百分比：' +
              '<span style="font-weight:600;">' +
              params.data.percentage +
              '%</span>'
            );
          },
        },
        legend: {
          orient: 'vertical',
          right: 4,
          y: 'center',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: '#fff',
            fontSize: '10px',
            height: 10,
            rich: {
              a: {
                verticalAlign: 'bottom',
              },
            },
          },
          selectedMode: false,
          selected,
          data: lodash.get(option, 'legend.data', []),
        },
        series: [
          {
            type: 'pie',
            center: ['24%', '50%'],
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
              color: '#fff',
            },
            labelLine: {
              show: false,
            },
            emphasis: {
              label: {
                show: true,
              },
            },
            data: lodash.map(lodash.get(option, 'series[0].data'), (item) => {
              return {
                name: item.lineOrGroup,
                value: item.situation,
                ...item,
              };
            }),
          },
        ],
      };

      res.optionPie = optionPie;
      this.Model.merge({ salesInfoRegistrar: res });
    } catch {}
  }
}
